<template>
<q-layout view="lhh LpR lff">
    <q-page-container>
      <q-page padding v-show="!load">
        <q-ajax-bar ref="bar" position="top" color="red-4" size="3px" skip-hijack></q-ajax-bar>
        <div class="row justify-between">
          <q-btn class="justify-center q-ma-xs q-pr-md" ripple dense flat color="black" to="/categories">
            <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
        </div>
        <q-card class="row q-my-xs">
          <div class="col-12 q-pa-md">
            <div class="text-h5 text-center q-py-xs">Danh sách nông trường</div>
          </div>
          <div class="col-12 col-sm-4 q-pa-md">
              <q-select v-if="!load"
              v-model= "farm"
              emit-value
              label="Nông trường"
              option-value="name"
              :options="farms"
              option-label="name"
              clearable
              :pagination= {rowsPerPage:0}
              >
                <template v-slot:prepend>
                  <q-icon name="filter_vintage" />
                </template>
              </q-select>
          </div>
        </q-card>

        <div v-for="(item, key) in farmsData" :key="key">
          <q-table
            :title="`${item.name} - Diện tích ${item.area.toFixed(2)} Ha - ${item.total} cây`"
            :data="item.listLot"
            :columns="headers2"
            row-key="name"
            no-data-label="Không có dữ liệu"
            :pagination.sync="pagination"
            :loading="load"
            class="q-mb-md"
            :hide-bottom="!_.isEmpty(item.listLot)"
            >
              <!-- LOT -->
            <template v-slot:body ="props">
              <q-tr @click.native="props.expand = !props.expand" :props="props">
                <q-td class="label-xs-right text-center">{{props.row.name}}</q-td>
                <q-td class="label-xs-right text-center">{{props.row.listSlot ? _.sumBy(props.row.listSlot, 'area').toFixed(2) : 0}}</q-td>
                <q-td class="label-xs-right text-center">{{props.row.listSlot ? _.sumBy(props.row.listSlot, 'total') : 0}}</q-td>
                <q-td class="label-xs-right text-center"><q-icon :name="props.expand ? 'arrow_drop_up' : 'arrow_drop_down'" size='20px'/></q-td>
              </q-tr>
              <!-- Lots table -->
              <q-tr v-show="props.row && props.expand" :props="props.listLot">
                <q-td colspan="100%">
                <q-table
                  :title="`Lô ${props.row.name}`"
                  :data="props.row.listSlot"
                  :columns="headers3"
                  row-key="name"
                  no-data-label="Không có dữ liệu"
                  :pagination.sync="pagination"
                  :loading="load"
                  class="q-mb-md"
                  :hide-bottom="!_.isEmpty(props.row.listSlot)"
                  />
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>


<script>
export default {
  data() {
    return {
      farms: [],
      farm: '',
      slotExpand: false,
      expandI: {},
      slotKey: 0,
      slotProp: '',
      load: false,
      headers3: [{
        label: "Ô",
        align: "center",
        name: "name",
        field: row => row.name,
        format: val => `${val}`,
      },
      {
        label: "Diện tích (Ha)",
        align: "center",
        name: "area",
        field: row => row.area,
        format: val => `${JSON.stringify(val)}`,
      },
      {
        label: "Số cây",
        align: "center",
        name: "total",
        field: row => row.total,
        format: val => `${val}`,
      }],
      headers2: [{
        label: "Lô",
        align: "center",
        name: "name",
        field: row => row.name,
        format: val => `${val}`,
        },
        {
        label: "Diện tích (Ha)",
        align: "center",
        name: "area",
        },
        {
        label: "Số cây",
        align: "center",
        name: "total",
        }],
      headers: [{
        label: "No",
        align: "center",
        name: "no",
        },
        {
        label: "Nông trường",
        align: "center",
        name: "farm"
        }],
      pagination: {
      hideBottom: true,
      rowsPerPage: 0,
      // sortBy: 'job'
      },
      lotHeaders: [{
        lable: ""
      }]
    }
  },
  mounted() {
    this.fetchData()
  },
  computed: {
    farmsData() {
      let vm = this
      vm.expandI = []
      //filter, sort, sum of area and total
      for (let i in vm.farms) {
        if (vm.farms[i].listLot) {
          vm.farms[i].area = 0
          vm.farms[i].total = 0
          vm.farms[i].listLot.sort((a,b) => a.id > b.id ? 1 : a.id == b.id ? 0 : -1)
          vm.farms[i].listLot.forEach(lot => {
          vm.farms[i].area += vm._.sumBy(lot.listSlot, 'area')
          vm.farms[i].total += vm._.sumBy(lot.listSlot, 'total')
          })
        }
        if (vm._.isEqual(vm.farms[i].name, vm.farm)) return [vm.farms[i]]
        }
      return vm.farms.sort((a,b) => a.id > b.id ? 1 : a.id == b.id ? 0 : -1)
    },
    expandItems: {
      get: function () {
        return this.expandI
      },
      set: function (newValue) {
        this.expandI = newValue
      }
    }
  },
  methods: {
    async fetchData() {
      let vm = this
      vm.load = true
      let res = await vm.$query(['Masterdata','Farm'])
      vm.farms = null
      this.farms = (res && res.list) ? res.list : []
      this.farms.sort((a, b) => a.name.localeCompare(b.name))
      vm.load = false
      return res
    },
    expand(item, index) {
      this.expandI[index] = this._.isEqual(item.listSlot, this.expandI[index]) ? {} : item.listSlot
      this.slotKey ++
    },
    routeData(dataId, mode) {
      this.$router.push({
        name: '/farms/entry',
        query: {
          id: dataId ? dataId : undefined,
        },
        params: {
          id: dataId,
          mode: mode ? mode : undefined
        }
      });
    },
  }
}
</script>
